import { render, staticRenderFns } from "./tour-card.vue?vue&type=template&id=614d0ccd&scoped=true&"
import script from "./tour-card.vue?vue&type=script&lang=js&"
export * from "./tour-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d0ccd",
  null
  
)

export default component.exports